<template>
  <div class="clients" v-if="documentList">
    <div class="clients__title">Documentations</div>
    <div class="clients__subtitle">Documents d’information</div>

    <div class="documentations__table">
      <div
        class="documentations__table__item"
        v-for="(document, index) in documentList.information"
        :key="index"
      >
        <!-- Document Name -->
        <div class="documentations__table__item--cell">
          {{ document.name }}
        </div>

        <!-- Download Button -->
        <a href="#" @click.stop="newDownloadFile(document.path, document.name)">
          <div class="documentations__table__item--cell icon-cell">
            <button class="download-button">
              <font-awesome-icon prefix="fas" icon="download" />
              Télécharger
            </button>
          </div>
        </a>
      </div>
    </div>

    <div class="clients__subtitle">Notices</div>

    <div class="documentations__table">
      <div
        class="documentations__table__item"
        v-for="(document, index) in documentList.notices"
        :key="index"
      >
        <!-- Document Name -->
        <div class="documentations__table__item--cell">
          {{ document.name }}
        </div>

        <!-- Download Button -->
        <div class="documentations__table__item--cell icon-cell">
          <button class="download-button" @click="newDownloadFile(document.path, document.name)">
            <font-awesome-icon prefix="fas" icon="download" />
            Télécharger
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "Documentations",
  data() {
    return {
      documentList: [],
    };
  },
  methods: {
    getDocumentList() {
      let url = `documents`;
      this.apiGet(url)
        .then((response) => {
          this.documentList = response.data;
        })
        .catch((error) => {
          this.showErrorNotification(error);
        });
    },
    
    sanitizeFilename(filename) {
      return filename.replace(/[<>:"/\\|?*]+/g, "_");
    },

    newDownloadFile(url, filename, callback = () => {}) {
      const sanitizedFilename = this.sanitizeFilename(filename);
      const fullUrl = this.getRawApiUrl(url);
      fetch(fullUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Error ${response.status}: ${response.statusText}`);
          }
          return response.blob();
        })
        .then((blob) => {
          const objectUrl = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = objectUrl;
          link.download = sanitizedFilename;
          document.body.appendChild(link); // Needed for Firefox
          link.click();
          link.remove();
          URL.revokeObjectURL(objectUrl);
          callback(); // Success callback
        })
        .catch((error) => {
          console.error("Error downloading the file", error);

          let errorMessage = "Failed to download the file. Please try again.";
          if (error.message) {
            errorMessage = error.message;
          }

          callback(); // Error callback
        });
    },
  },
  mounted() {
    this.getDocumentList();
  },
};
</script>
  
  <style scoped>
.documentations__table {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* Two columns */
  gap: 20px; /* Space between rows and columns */
}

.icon-cell {
  width: 140px; /* Fixed width for the cell containing the button */
}

.icon-cell .download-button {
  width: 100%; /* Button takes full width of its container */
  /* other properties remain the same */
}

.documentations__table__item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: #f9f9f9;
  border-radius: 5px;
}

.documentations__table__item--cell {
  font-size: 1.2rem;
}

.icon-cell .download-button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 5px 15px;
  border-radius: 5px;
  cursor: pointer;
  width: 140px; /* Fixed width for consistent button size */
  display: flex;
  align-items: center;
  justify-content: center; /* Center the content */
}

.icon-cell .download-button:hover {
  background-color: #0056b3;
}

.icon-cell .download-button font-awesome-icon {
  margin-right: 8px; /* Add spacing between icon and text */
}
</style>


// WEBPACK FOOTER //
// src/components/Documentations/Documentations.vue